<app-header [forceLightBackground]="true"></app-header>
<div class="admin-data-upload-requests-home">
  <div class="admin-data-upload-requests-home--layout">
    <app-admin-sidebar class="admin-data-upload-requests-home--sidebar"></app-admin-sidebar>
    <div class="admin-data-upload-requests-home--content">
      <app-page-header></app-page-header>
      <div class="data-upload-requests-home-container">
        <!-- Tabs -->
        <div class="data-upload-requests-tabs">
          <button
            class="data-upload-requests-tab"
            [class.active]="activeTab === 'sftp'"
            (click)="setActiveTab('sftp')"
            type="button"
          >
            SFTP requests
          </button>
          <button
            class="data-upload-requests-tab"
            [class.active]="activeTab === 'api'"
            (click)="setActiveTab('api')"
            type="button"
          >
            API request
          </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <app-sftp-requests *ngIf="activeTab === 'sftp'"></app-sftp-requests>
          <app-api-requests *ngIf="activeTab === 'api'"></app-api-requests>
        </div>
      </div>
    </div>
  </div>
</div>
